import About from '../About';
import ProjectsSection from '../Projects/ProjectsSection';
import Skills from '../Skills';
import ExperienceSection from '../ExperienceSection';
import CertificatesSection from '../Certificates/CertificatesSection';
import ContactSection from '../Contact/ContactSection';

/**
 * MobileFallback — single-page stack vertical.
 * viewport < 768px → desktop OS pesado demais (canvas RAF, Rnd drag).
 *
 * Renderiza as mesmas sections em ordem, com wallpaper matrix estático e
 * header simplificado. Sem janelas, sem taskbar, sem palette.
 */
export default function MobileFallback() {
  return (
    <div className="min-h-screen w-full bg-[var(--bg-deep)] text-[var(--text-primary)] font-mono">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-[var(--bg-deep)]/85 backdrop-blur border-b border-[var(--neon-cyan)]/20 px-4 py-3">
        <div className="flex items-center gap-2">
          <span className="relative inline-flex w-2 h-2 rounded-full bg-[var(--neon-green)] shadow-[0_0_8px_var(--neon-green)]">
            <span className="absolute inset-0 rounded-full animate-ping bg-[var(--neon-green)] opacity-60" />
          </span>
          <span className="font-display text-sm tracking-[0.3em] text-[var(--neon-cyan)] uppercase">
            Blade OS
          </span>
          <span className="ml-auto text-[0.65rem] text-[var(--text-muted)] uppercase tracking-wider">
            mobile mode
          </span>
        </div>
        <p className="mt-1 text-[0.7rem] text-[var(--text-muted)]">
          Desktop OS only for ≥768px. Use mobile device for full experience.
        </p>
      </header>

      {/* Sections stack */}
      <main className="px-4 py-6 space-y-8">
        <About />
        <Skills />
        <ProjectsSection />
        <ExperienceSection />
        <CertificatesSection />
        <ContactSection />

        <footer className="pt-6 pb-12 border-t border-[var(--neon-cyan)]/15 text-center text-[0.7rem] text-[var(--text-muted)]">
          <span className="text-[var(--neon-cyan)]">pedro riccio</span> · blade os v2.0
        </footer>
      </main>
    </div>
  );
}
